<template>
    <form class="-client-add"
          v-on:submit.prevent="submit"
          action="">
        <person-form :data.sync="data"></person-form>

        <div class="row">
            <div class="col-sm-12 cta">
                <button type="submit" class="btn btn-primary -add-individual">
                    Créer
                </button>
            </div>
        </div>
    </form>
</template>

<script type="text/ecmascript-6">
    import PersonForm from './PersonForm';
    import {dataToContact, makeDefaultData} from './utils';

    export default {
        components: {
            PersonForm
        },
        data() {
            return {
                data: makeDefaultData()
            };
        },
        computed: {
            clientData() {
                return {
                    type: 'individual',
                    name: this.data.first_name + ' ' +
                        this.data.last_name,
                    status: 'prospect',
                    contacts: [dataToContact(this.data)]
                };
            }
        },
        methods: {
            submit() {
                this.$dispatch('clients:add', this.clientData);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// AddIndividual.vue?0cef6712